import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Form,
  Input,
  Label,
  Nav,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
} from "reactstrap";
import classnames from "classnames";
import progileBg from "../../../../assets/images/profile-bg.jpg";
import avatar1 from "../../../../assets/images/users/avatar-1.jpg";
import { getAccountQuery, getDevicesQuery } from "../../../../queries";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import settings from "../../../../settings/settings";
import moment from "moment";
import { terminateDevice, uploadAvatar } from "../../../../api/user";
import { DefaultComissions } from "../../../../Components/custom/DefaultComissions";
import { useTranslation } from "react-i18next";

const Settings = () => {
  const [phone, setPhone] = useState("");
  const [activeTab, setActiveTab] = useState("2");
  const queryClient = useQueryClient();
  const { t } = useTranslation();

  const { data: account } = useQuery({
    ...getAccountQuery(),
  });

  const { data: devices } = useQuery({
    ...getDevicesQuery(),
  });

  const terminate = (id) => {
    terminateDevice(id).then(() => {
      queryClient.invalidateQueries({ queryKey: ["devices"] });
    });
  };

  const handleAvatar = (image) => {
    const formData = new FormData();
    formData.append("image", image);
    uploadAvatar(formData)
      .then(() => {
        setTimeout(() => {
          queryClient.invalidateQueries({
            queryKey: ["account"],
            refetchType: "all",
          });
        }, 2000);
      })
      .catch((err) => console.log(err));
  };

  const tabChange = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  useEffect(() => {
    if (account) {
      setPhone(account.data.phoneNumber);
    }
  }, [account]);

  document.title = "Profile Settings | Bazaar";

  return (
    account && (
      <div className="page-content">
        <Container fluid>
          <div className="position-relative mx-n4 mt-n4">
            <div className="profile-wid-bg profile-setting-img">
              <img src={progileBg} className="profile-wid-img" alt="" />
            </div>
          </div>
          <Row>
            <Col xxl={3}>
              <Card className="mt-n5">
                <CardBody className="p-4">
                  <div className="text-center">
                    <div className="profile-user position-relative d-inline-block mx-auto  mb-4">
                      <img
                        src={
                          account.data.images?.[0]?.id
                            ? `${settings.baseURL}/account/images/${account.data.images?.[0]?.id}`
                            : avatar1
                        }
                        className="rounded-circle avatar-xl img-thumbnail user-profile-image"
                        alt="user-profile"
                      />
                      <div className="avatar-xs p-0 rounded-circle profile-photo-edit">
                        <Input
                          id="profile-img-file-input"
                          type="file"
                          className="profile-img-file-input"
                          onChange={(e) => handleAvatar(e.target.files[0])}
                        />
                        <Label
                          htmlFor="profile-img-file-input"
                          className="profile-photo-edit avatar-xs"
                        >
                          <span className="avatar-title rounded-circle bg-light text-body">
                            <i className="ri-camera-fill"></i>
                          </span>
                        </Label>
                      </div>
                    </div>
                    <h5 className="fs-16 mb-1">
                      {`${account.data.firstName} 
                      ${account.data.lastName || ""}`}
                    </h5>
                    <p className="text-muted mb-0">
                      {account.data.roles.join(", ")}
                    </p>
                  </div>
                </CardBody>
              </Card>
            </Col>

            <Col xxl={9}>
              <Card className="mt-xxl-n5">
                <CardHeader>
                  <Nav
                    className="nav-tabs-custom rounded card-header-tabs border-bottom-0"
                    role="tablist"
                  >
                    {/* <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "1" })}
                        onClick={() => {
                          tabChange("1");
                        }}
                      >
                        <i className="fas fa-home"></i>
                        {t("Personal Details")}
                      </NavLink>
                    </NavItem> */}
                    <NavItem>
                      <NavLink
                        to="#"
                        className={classnames({ active: activeTab === "2" })}
                        onClick={() => {
                          tabChange("2");
                        }}
                        type="button"
                      >
                        <i className="far fa-user"></i>
                        {t("Devices")}
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        to="#"
                        className={classnames({ active: activeTab === "3" })}
                        onClick={() => {
                          tabChange("3");
                        }}
                        type="button"
                      >
                        <i className="far fa-user"></i>
                        {t("Default comission")}
                      </NavLink>
                    </NavItem>
                  </Nav>
                </CardHeader>
                <CardBody className="p-4">
                  <TabContent activeTab={activeTab}>
                    <TabPane tabId="1">
                      <Form>
                        <Row>
                          <Col lg={12}>
                            <div className="mb-4">
                              <Label
                                htmlFor="phonenumberInput"
                                className="form-label"
                              >
                                {t("Phone")}
                              </Label>
                              <Input
                                type="text"
                                className="form-control"
                                id="phonenumberInput"
                                placeholder={t("Phone")}
                                value={phone}
                                onChange={(e) => setPhone(e.target.value)}
                              />
                            </div>
                          </Col>

                          {/* <Col lg={12}>
                            <div className="hstack gap-2 justify-content-end">
                              <button type="button" className="btn btn-primary">
                                {t("Update")}
                              </button>
                              <button
                                type="button"
                                className="btn btn-soft-success"
                              >
                                Cancel
                              </button>
                            </div>
                          </Col> */}
                        </Row>
                      </Form>
                    </TabPane>

                    <TabPane tabId="2">
                      {devices?.data?.data.map((session) => (
                        <div
                          className="d-flex align-items-center mb-3"
                          key={session.id}
                        >
                          <div className="flex-shrink-0 avatar-sm">
                            <div className="avatar-title bg-light text-primary rounded-3 fs-18">
                              <i
                                className={
                                  session.displayName.includes("Windows")
                                    ? "ri-macbook-line"
                                    : "ri-smartphone-line"
                                }
                              ></i>
                            </div>
                          </div>
                          <div className="flex-grow-1 ms-3">
                            <h6>{session.displayName}</h6>
                            <p className="text-muted mb-0">
                              {session.ipAddress} -{" "}
                              {moment(session.lastActive).format(
                                "DD MMMM, hh:mm"
                              )}
                            </p>
                          </div>
                          <div>
                            <a href="#" onClick={() => terminate(session.id)}>
                              {t("Logout")}
                            </a>
                          </div>
                        </div>
                      ))}
                    </TabPane>

                    <TabPane tabId="3">
                      <DefaultComissions />
                    </TabPane>
                  </TabContent>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    )
  );
};

export default Settings;
